// eslint-disable-next-line import/no-cycle
import { useUserInfo } from 'context/user'
import { useOtpAction } from 'context/otpAction'
import localforage from 'localforage'
import { useNavigate } from 'react-router-dom'

function useAuth() {
  const [user] = useUserInfo()
  return user?.token
}

function useLogout() {
  const clear    = useUserInfo()[2]
  const { clearVerified } = useOtpAction()
  const navigate = useNavigate()

  return async () => {
    // Clear the 3-hour OTP-verified session so the next admin signing in
    // on this browser doesn't inherit it.
    await clearVerified()
    await localforage.clear()
    clear()
    navigate('/auth/sign-in')
  }
}

export { useAuth, useLogout }
